import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { UserSearchResult } from "@/lib/types";

/** Search the JIT user pool (everyone who has logged in to Flow at least
 * once). `enabled=false` for empty queries to avoid wasted requests. */
export function useUserSearch(query: string, enabled = true) {
  const q = query.trim();
  return useQuery<UserSearchResult[]>({
    enabled: enabled && q.length >= 1,
    queryKey: queryKeys.userSearch(q),
    queryFn: () => api.searchUsers(q, 20),
    staleTime: 30_000,
  });
}
